import * as __WEBPACK_EXTERNAL_MODULE_tailwind_variants_6759ef11__ from "tailwind-variants";
const config = {
    twMerge: true,
    twMergeConfig: {
        prefix: 'ptw-',
        theme: {
            borderWidth: [
                'thin',
                'medium',
                'thick'
            ],
            opacity: [
                'strong',
                'medium',
                'weak',
                'subtle',
                'tonal',
                'none'
            ],
            borderRadius: [
                'sharp',
                'extra',
                'extreme',
                'pill',
                'circle'
            ]
        },
        classGroups: {
            'font-size': [
                {
                    text: [
                        'body-xs',
                        'body-sm',
                        'body-md',
                        'body-lg',
                        'title-sm',
                        'title-md',
                        'title-lg',
                        'display-md',
                        'disply-lg'
                    ]
                }
            ],
            shadow: [
                {
                    shadow: [
                        'weak',
                        'strong',
                        'line',
                        'lineMedium',
                        'lineThick',
                        'lineThicker'
                    ]
                }
            ],
            'bg-image': [
                {
                    bg: [
                        'gradient-radial',
                        'gradient-conic'
                    ]
                }
            ]
        }
    }
};
const pdsTv = (tvVariants)=>(0, __WEBPACK_EXTERNAL_MODULE_tailwind_variants_6759ef11__.tv)(tvVariants, config);
export { pdsTv };
